// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"537":"e16b1f03","651":"f294b23a"}[chunkId] + ".chunk.js";
};